import { render, staticRenderFns } from "./PhotoInvertedIcon.vue?vue&type=template&id=19b509ec&scoped=true"
import script from "./PhotoInvertedIcon.vue?vue&type=script&lang=js"
export * from "./PhotoInvertedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b509ec",
  null
  
)

export default component.exports